import React from 'react';
import VehicleEntityGridPage from './VehicleEntityGridPage';
import { VEHICLE_FINES } from './vehicleEntityConfigs';

const VehicleFineRecords = () => <VehicleEntityGridPage config={VEHICLE_FINES} />;

export default VehicleFineRecords;
